export default __webpack_public_path__ + "static/media/top-banner.ee4655fa.png";